import makeStyles from '@mui/styles/makeStyles';
import {styled} from "@mui/material";
import {Paper} from "@mui/material";
import {useTheme} from "@mui/styles";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const menuPaperStyle = {
    // Altezza e larghezza massima, necessarie a rendere il menu scrollabile
    maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    width: 250,// Larghezza che preferisci
    border: '1px solid var(--atl-border)',
    backgroundColor: 'var(--atl-surface-solid-strong)',
    backgroundImage: 'none',
    color: 'var(--atl-text)',
    boxShadow: 'var(--atl-shadow)',
    backdropFilter: 'none',
    WebkitBackdropFilter: 'none',
    /*
      -- STILE SCROLLBAR WebKit (Chrome, Safari, Opera, Edge Chromium) --
      Rende la scrollbar molto sottile, leggermente trasparente in stile Apple.
    */
    '&::WebkitScrollbar': {
        width: 6,                 // larghezza barra
        backgroundColor: 'transparent'
    },
    '&::WebkitScrollbarTrack': {
        backgroundColor: 'transparent'
    },
    '&::WebkitScrollbarThumb': {
        backgroundColor: 'rgba(0, 0, 0, 0.2)', // sottile, scura e semitrasparente
        borderRadius: 3
    },
    '&::WebkitScrollbarThumb:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.4)'
    },

    /*
      -- STILE SCROLLBAR Firefox --
      "thin" rende la scrollbar più sottile.
      "scrollbar-color" definisce colore del thumb e background del track.
    */
    scrollbarWidth: 'thin',
    scrollbarColor: 'rgba(0, 0, 0, 0.2) transparent'
};

export const MenuProps = {
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
    },
    transformOrigin: {
        vertical: 'top',
        horizontal: 'left'
    },
    slotProps: {
        paper: {
            style: menuPaperStyle
        }
    }
};

export const dynamicFormStyle = makeStyles(theme => ({
    rowContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        // In v4 "gap" non è supportato in modo nativo. Si può emulare con margin:
        marginBottom: 10,
        '& > *': {
            marginRight: 20,
            marginBottom: 10
        }
    },
    fieldItem: {
        flex: 1,
        minWidth: 0
    },
    largerBold: {
        fontSize: '1.5rem',
        fontWeight: 'bold'
    },
    glowYellow: {
        color: '#000',
        textShadow: '0 0 5px #ff0, 0 0 10px #ff0, 0 0 15px #ff0, 0 0 20px #ff0',
        marginBottom: 20,
        marginTop: 20
    },
    loadingContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
    },
    mbt20: {
        marginBottom: 20,
        marginTop: 20
    },
    // Stili per sostituire alcuni "sx" usati nel codice
    flexAlignCenter: {
        display: 'flex',
        alignItems: 'center'
    },
    ml2: {
        marginLeft: theme.spacing(2)
    },
    mb2: {
        marginBottom: theme.spacing(2)
    },
    justifyEnd: {
        justifyContent: 'flex-end'
    },
    customMenuPaper: {
        // Altezza e larghezza massima, necessarie a rendere il menu scrollabile
        maxHeight: 200,
        width: 250,

        /*
          -- STILE SCROLLBAR WebKit (Chrome, Safari, Opera, Edge Chromium) --
          Rende la scrollbar molto sottile, leggermente trasparente in stile Apple.
        */
        '&::WebkitScrollbar': {
            width: 6,                 // larghezza barra
            backgroundColor: 'transparent'
        },
        '&::WebkitScrollbarTrack': {
            backgroundColor: 'transparent'
        },
        '&::WebkitScrollbarThumb': {
            backgroundColor: 'rgba(0, 0, 0, 0.2)', // sottile, scura e semitrasparente
            borderRadius: 3
        },
        '&::WebkitScrollbarThumb:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.4)'
        },

        /*
          -- STILE SCROLLBAR Firefox --
          "thin" rende la scrollbar più sottile.
          "scrollbar-color" definisce colore del thumb e background del track.
        */
        scrollbarWidth: 'thin',
        scrollbarColor: 'rgba(0, 0, 0, 0.2) transparent'
    },
    tooltip:{
        marginTop: 5,
    },
}));

export const PaperComponent = (props) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === "dark";

    return (
        <Paper
            {...props}
            style={{
                overflowY: "auto",
                scrollbarWidth: 'none',
                scrollbarColor: isDarkMode ? "#888888 #444444" : "#B0B0B0 #E0E0E0",
                wordBreak: "break-word", // Permette di spezzare le parole lunghe
                overflowWrap: "break-word", // Alternativa per garantire la rottura delle parole
            }}
        >
            {props.children}
        </Paper>
    );
};
